import React from "react";
import {
  Container,
  Title,
  Header,
  HeaderTitle,
  HeaderIconLeft,
  HeaderIconRight,
  TableContainer,
  TableHeader,
  TableBody,
} from "./Services Trash Component/TableComponent/Table";
import InputSearch from "./Services Trash Component/Search/Search";
import PickColumn from "./Services Trash Component/PickColumn/PickColumn";
import Action from "./Services Trash Component/Action/Action";
import AddGroup from "./Services Trash Component/AddGroup/AddGroup";
import CreatedOn from "./Services Trash Component/CreatedOn/CreatedOn";
import Filter from "./Services Trash Component/Filter/Filter";
import { osplist } from "./Services Trash Component/Utils/Utils";

export default function AllSeller() {
  const RowHeader = [
    "Service ID",
    "Status",
    "Service Name",
    "Service Categories",
    "Service HSN Code ",
    "Phone No",
    "Assigned to",
    "Tags",
    "Actions",
  ];

  const path = "/admin-dashboard/services/view-service/LBIN256347";
  return (
    <div className="mt-10"> 
      <Container>
        <Title showImport={false}>All Seller</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={osplist}
              // isLoading={isLoading}
              // error={error}
                path={path}
            />
          </TableContainer>
        </Header>
      </Container>
      
    </div>
  );
}
